<template>
  <div class="c_time" ref="timer">
    <p v-if="next_phase">
      第
      <span class="tc">{{next_phase}}</span>
      期 距封盘:
      <span v-if="r_time>0" class="tc">{{r_time|secondsFormat}}</span>
      <span v-else class="tc">已封盘</span>
    </p>
    <p v-else>暂无期数</p>
    <DownTime
      @before_end="$emit('before_end')"
      :remain_time="remain_time"
      :block_time="block_time"
      @end="handleEnd" @change="handleChange"
      class="countdown"/>
  </div>
</template>

<script>
  import {CountDown} from 'mini-countdown/components';
  import Vue from "@/utils/bus"
  import DownTime from '../../components/down-time';

  export default {
    name: "c_time",
    components: {
      CountDown,
      DownTime
    },
    props: {
      remain_time: Number,
      block_time: Number,
      next_phase: {
        type: String,
        default: ''
      },
      time: {
        type: String,
        default: '' // hh:mm:ss
      }
    },
    filters: {
      secondsFormat(s) {
        var day = Math.floor(s / (24 * 3600)); // Math.floor()向下取整
        var hour = Math.floor((s - day * 24 * 3600) / 3600);
        var minute = Math.floor((s - day * 24 * 3600 - hour * 3600) / 60);
        var second = s - day * 24 * 3600 - hour * 3600 - minute * 60;
        if (hour) {
          return hour + "时:" + minute + "分:" + second + "秒";
        } else {
          if (second < 10) {
            if (minute < 10) {
              return "0时:" + minute + "分:" + second + "秒";
            } else {
              return "0时:" + minute + "分:" + second + "秒";
            }
          } else {
            return "0时:" + minute + "分:" + second + "秒";
          }
        }
      }
    },
    data() {
      return {
        r_time: 0
      }
    },
    mounted() {
      this.$emit('change', this.r_time);

    },
    methods: {
      handleChange({time}) {
        this.r_time = time;
        this.$emit('change', this.r_time);
        Vue.$emit('changeTime',this.r_time);
      },
      handleEnd(ctx) {
        this.$emit('end', ctx);
      }
    }
  }
</script>

<style scoped lang="stylus">
 @media screen and (max-width: 900px) {
    .c_time{float:left !important;font-size:12px !important;width:350px !important}
  }
  .c_time {
    width 457px
    height 100%
    padding 0 10px
    font-size 14px
    background #fff
    box-sizing border-box
    font-weight bold
    border-radius 2px
    line-height 25px

    .countdown {
      margin-top 0px
    }
    p{padding-left: 5px;
    display inline
  }

  }
</style>



// WEBPACK FOOTER //
// src/components/c_top-time/index.vue